<template>
  <div>
    <div class="banner">
      <img src="../assets/images/material.png" alt="" />
    </div>
    <div class="greenest">
      <div class="greenest_">
        <div class="tltle">无环保 不装修</div>
        <img
          src="../assets/images/greenestImg1.png"
          alt=""
          class="greenestImg1"
        />
        <div class="greenestTitle">
          <p>甲醛集中3大源头：板、胶、漆</p>
          <span>怎么装严选远高于国家标准，从源头解决甲醛污染</span>
        </div>
        <ul>
          <img src="../assets/images/greenestImg2.png" alt="" />
          <img src="../assets/images/greenestImg3.png" alt="" />
          <img src="../assets/images/greenestImg4.png" alt="" />
        </ul>
        <img src="../assets/images/greenestImg5.png" alt="" class="say-no" />
      </div>
    </div>

    <div class="material">
      <div class="majorMaterial">
        <div class="material_title">品质辅材</div>
        <ul class="materialNav">
          <li>
            <img src="../assets/images/materialLogo (1).png" alt="" />
            <div>
              <p>安全</p>
              <p>无忧</p>
            </div>
          </li>
          <li>
            <img src="../assets/images/materialLogo (2).png" alt="" />
            <div>
              <p>经久</p>
              <p>耐用</p>
            </div>
          </li>
          <li>
            <img src="../assets/images/materialLogo (3).png" alt="" />
            <div>
              <p>环保</p>
              <p>无害</p>
            </div>
          </li>
        </ul>
        <ul class="materialImg">
          <img :src="item" alt="" v-for="item in majorMaterial" :key="item" />
        </ul>
      </div>
      <div class="majorMaterial major">
        <div class="material_title">严选主材</div>
        <ul class="materialNav">
          <li>
            <img src="../assets/images/materialLogo (4).png" alt="" />
            <div>
              <p>优中</p>
              <p>选优</p>
            </div>
          </li>
          <li>
            <img src="../assets/images/materialLogo (5).png" alt="" />
            <div>
              <p>品牌</p>
              <p>保障</p>
            </div>
          </li>
          <li>
            <img src="../assets/images/materialLogo (6).png" alt="" />
            <div>
              <p>正品</p>
              <p>保证</p>
            </div>
          </li>
        </ul>
        <ul class="materialImg">
          <img :src="item" alt="" v-for="item in Auxiliary" :key="item" />
        </ul>
      </div>
    </div>

    <div class="Skills">
      <p>优选材料，更要有俞润匠人们的精选技艺</p>
      <button @click="$router.push('/craft')">去看看工艺</button>
    </div>
    <div class="promise">
      <div class="promiseTitle">怎么装品牌承诺</div>
      <ul>
        <li>
          <img
            src="../assets/images/promiseImg (3).png"
            alt=""
            class="promiseImg"
          />
          <div>
            <img src="../assets/images/promiseLogo (1).png" alt="" />
            <p>本公司所售建材，同一品牌同一型号同一时间段，价高补差</p>
          </div>
        </li>
        <li>
          <img
            src="../assets/images/promiseImg (2).png"
            alt=""
            class="promiseImg"
          />
          <div>
            <img src="../assets/images/promiseLogo (2).png" alt="" />
            <p>本公司所有建材均为正品，若以次充好，退一赔一</p>
          </div>
        </li>
        <li>
          <img
            src="../assets/images/promiseImg (1).png"
            alt=""
            class="promiseImg"
          />
          <div>
            <img src="../assets/images/promiseLogo (3).png" alt="" />
            <p>
              本公司所有建材均达到国家环保标准，若单一建材检测不符合国家标准，全额退款
            </p>
          </div>
        </li>
      </ul>
      <button @click="$router.push('/Baojia')">联系我们</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      majorMaterial: [
        require("../assets/images/Main material (1).jpg"),
        require("../assets/images/Main material (2).jpg"),
        require("../assets/images/Main material (3).jpg"),
        require("../assets/images/Main material (4).jpg"),
        require("../assets/images/Main material (5).jpg"),
        require("../assets/images/Main material (6).jpg"),
        require("../assets/images/Main material (7).jpg"),
        require("../assets/images/Main material (8).jpg"),
        require("../assets/images/Main material (9).jpg"),
        require("../assets/images/Main material (10).jpg"),
        require("../assets/images/Main material (11).jpg"),
        require("../assets/images/Main material (12).jpg"),
        require("../assets/images/Main material (13).jpg"),
        require("../assets/images/Main material (14).jpg"),
        require("../assets/images/Main material (15).jpg"),
        require("../assets/images/Main material (16).jpg"),
        require("../assets/images/Main material (17).jpg"),
        require("../assets/images/Main material (18).jpg"),
        require("../assets/images/Main material (19).jpg"),
        require("../assets/images/Main material (20).jpg"),
        require("../assets/images/Main material (21).jpg"),
        require("../assets/images/Main material (22).jpg"),
        require("../assets/images/Main material (23).jpg"),
        require("../assets/images/Main material (24).jpg"),
        //   require('../assets/images/Main material (25).jpg'),
      ],
      Auxiliary: [
        require("../assets/images/Auxiliary materials (1).png"),
        require("../assets/images/Auxiliary materials (2).png"),
        require("../assets/images/Auxiliary materials (3).png"),
        require("../assets/images/Auxiliary materials (4).png"),
        require("../assets/images/Auxiliary materials (5).png"),
        require("../assets/images/Auxiliary materials (6).png"),
        require("../assets/images/Auxiliary materials (7).png"),
        require("../assets/images/Auxiliary materials (8).png"),
        require("../assets/images/Auxiliary materials (9).png"),
        require("../assets/images/Auxiliary materials (10).png"),
        require("../assets/images/Auxiliary materials (11).png"),
        require("../assets/images/Auxiliary materials (12).png"),
        require("../assets/images/Auxiliary materials (13).png"),
        require("../assets/images/Auxiliary materials (14).png"),
        require("../assets/images/Auxiliary materials (15).png"),
        require("../assets/images/Auxiliary materials (16).png"),
        require("../assets/images/Auxiliary materials (17).png"),
        require("../assets/images/Auxiliary materials (18).png"),
        require("../assets/images/Auxiliary materials (19).png"),
        require("../assets/images/Auxiliary materials (20).png"),
        require("../assets/images/Auxiliary materials (21).png"),
        require("../assets/images/Auxiliary materials (22).png"),
        require("../assets/images/Auxiliary materials (23).png"),
        require("../assets/images/Auxiliary materials (24).png"),
        //   require('../assets/images/Auxiliary materials (25).png'),
      ],
    };
  },
  methods: {},
  components: {},
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.banner {
  width: 100%;
  overflow: hidden;
  img {
    width: 100%;
    float: left;
  }
}
.greenest {
  width: 100%;
  background: url("../assets/images/greenestBg.png") no-repeat;
  background-size: cover;
  .greenest_ {
    padding: 25px 10px 35px;
    .tltle {
      display: flex;
      justify-content: center;
      font-size: 20px;
      font-weight: bold;
    }
    .greenestImg1 {
      width: 100%;
      margin-bottom: 10px;
    }
    .greenestTitle {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 20px;
      p {
        font-size: 16px;
        margin-bottom: 8px;
      }
      span {
        font-size: 8px;
        color: #949494;
      }
    }
    ul {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-column-gap: 5px;
      margin-bottom: 20px;
      img {
        width: 100%;
      }
    }
    .say-no {
      width: 180px;
      display: block;
      margin: 0 auto;
    }
  }
}
.material {
  width: 100%;
  .majorMaterial {
    width: 100%;
    background: url("../assets/images/AuxiliaryBg.png") no-repeat;
    padding: 25px 10px 55px;
    background-size: cover;
    .material_title {
      width: 100%;
      display: flex;
      justify-content: center;
      font-size: 18px;
      color: #fff;
      margin-bottom: 40px;
    }
    .materialNav {
      display: flex;
      width: 100%;
      padding: 0px 10px;
      margin-bottom: 25px;
      justify-content: space-between;

      li {
        width: 100%;
        display: flex;
        align-items: center;
        img {
          width: 30px;
          margin-right: 5px;
        }
        div {
          padding-left: 5px;
          border-left: 1px solid #fff;
          p {
            font-size: 12px;
            color: #fff;
          }
        }
      }
    }
    .materialImg {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-column-gap: 3px;
      grid-row-gap: 3px;
      overflow: hidden;
      img {
        width: 100%;
        float: left;
      }
    }
  }
}
.major {
  background: url("../assets/images/majorBg.png") no-repeat !important;
  .material_title {
    color: #000 !important;
  }
  .materialNav {
    li {
      div {
        border-left: 1px solid #000 !important;
        p {
          color: #000 !important;
        }
      }
    }
  }
}
.Skills {
  width: 100%;
  padding: 30px 0px 18px 0px;
  background: url("../assets/images/Skills.png") no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    font-size: 10px;
    color: #fff;
    margin-bottom: 12px;
  }
  button {
    width: 80px;
    height: 20px;
    font-size: 10px;
    background-color: #ffde03;
    border: none;
  }
}
.promise {
  width: 100%;
  padding: 35px 10px 30px;
  background-color: #fff;
 
  .promiseTitle {
    display: flex;
    justify-content: center;
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 40px;
  }
  ul {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 10px;
    li {
      width: 100%;
      border: 1px solid #d5d5d5;
      overflow: hidden;

      .promiseImg {
        width: 100%;
      }
      div {
        width: 100%;
        border-top: none;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 15px 5px 12px 5px;
        height: 120px;
        img {
          width: 35px;
          margin-bottom: 8px;
        }
        p {
          font-size: 8px;
        }
      }
    }
  }
  button{
      width: 90px;
      height: 22px;
      font-size: 10px;
      border: none;
      margin: 0 auto;
       margin-top: 22px;
       background-color: #ffde03;
       display: block;
         
  }
}
</style>
